import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Badge,
  Progress,
  Collapse,
  Button,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import { showAlert } from "components/CommonComponents/CommonFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";

/* STATIC DATA */
const courseFlow = [
  {
    id: "L1",
    type: "LESSON",
    order: 1,
    title: "Introduction to Electrical Safety",
    progress: 90,
    minProgress: 80,
    attendance: 95,
    minAttendance: 75,
  },
  {
    id: "A1",
    type: "ASSESSMENT",
    order: 1,
    title: "Electrical Safety Quiz",
    score: 78,
    passingScore: 60,
    maxAttempts: 3,
    attemptsUsed: 1,
  },
  {
    id: "L2",
    type: "LESSON",
    order: 2,
    title: "Hazard Identification",
    progress: 70,
    minProgress: 80,
    attendance: 85,
    minAttendance: 75,
  },
  {
    id: "L3",
    type: "LESSON",
    order: 3,
    title: "Protective Equipment",
    progress: 100,
    minProgress: 80,
    attendance: 100,
    minAttendance: 75,
  },
  {
    id: "A2",
    type: "ASSESSMENT",
    order: 2,
    title: "Final Assessment",
    score: 55,
    passingScore: 60,
    maxAttempts: 2,
    attemptsUsed: 2,
  },
];

const IssuanceDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;
  const [openSectionId, setOpenSectionId] = useState(courseFlow[0].id);

  useEffect(() => {
    if (decodedId) {
    }
  }, [decodedId]);

  const toggleSection = (id) => {
    setOpenSectionId((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <AdminHeader />
      {/* name="Certificate Issuance Details" */}

      <Container fluid className="mt--6">
        <Row>
          <Col>
            <div
              className="d-flex align-items-center cursor text-white mb-5"
              onClick={() => navigate(-1)}
            >
              <i className="fa-solid fa-angle-left mr-2" />
              <span className="font-weight-bold">Back</span>
            </div>
            <div className="mt--4">
              {courseFlow.map((item) => (
                <Card key={item.id} className="mb-3">
                  <CardHeader className="d-flex align-items-center">
                    <div
                      className="d-flex align-items-center cursor-pointer"
                      onClick={() => toggleSection(item.id)}
                    >
                      <i
                        className={`fa fa-chevron-${
                          openSectionId === item.id ? "up" : "down"
                        }`}
                      />
                      <h5 className="ml-2 mb-0">
                        {item.type === "LESSON"
                          ? `Lesson ${item.order}`
                          : `Assessment ${item.order}`}{" "}
                        – {item.title}
                      </h5>
                    </div>
                  </CardHeader>

                  <Collapse isOpen={openSectionId === item.id}>
                    <CardBody>
                      {item.type === "LESSON" && (
                        <Row>
                          <Col md="6">
                            <label>Progress</label>
                            <Progress
                              value={item.progress}
                              color={
                                item.progress >= item.minProgress
                                  ? "success"
                                  : "danger"
                              }
                              className="progress-bar-custom"
                            />
                            <small>
                              {item.progress}% (Min {item.minProgress}%)
                            </small>
                          </Col>

                          <Col md="6">
                            <label>Attendance</label>
                            <Progress
                              value={item.attendance}
                              color={
                                item.attendance >= item.minAttendance
                                  ? "success"
                                  : "danger"
                              }
                              className="progress-bar-custom"
                            />
                            <small>
                              {item.attendance}% (Min {item.minAttendance}%)
                            </small>
                          </Col>
                        </Row>
                      )}

                      {item.type === "ASSESSMENT" && (
                        <Row>
                          <Col md="4">
                            <label>Score</label>
                            <div>
                              {item.score} / {item.passingScore}
                            </div>
                          </Col>

                          <Col md="4">
                            <label>Status</label>
                            <Badge
                              color={
                                item.score >= item.passingScore
                                  ? "success"
                                  : "danger"
                              }
                            >
                              {item.score >= item.passingScore
                                ? "Passed"
                                : "Failed"}
                            </Badge>
                          </Col>

                          <Col md="4">
                            <label>Attempts</label>
                            <div>
                              {item.attemptsUsed} / {item.maxAttempts}
                            </div>
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  </Collapse>
                </Card>
              ))}
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end align-items-center mt-3">
            <Button
              color="deep-blue"
              onClick={() =>
                showAlert({
                  type: "warning",
                  title: "Issue Certificate",
                  message: "Are you sure you want to issue the certificate?",
                  confirmText: "Issue",
                  cancelText: "Cancel",
                  confirmStyle: "success",
                  cancelStyle: "secondary",
                  showCancel: true,
                  onConfirm: () => {},
                })
              }
            >
              Issue Certificate
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default IssuanceDetails;
